<button
  class="action-btn {{ type }}-btn"
  [class.full-width]="fullWidth"
  [class.loading-effect]="isLoading"
  [class.abbreviated]="abbreviation"
  [disabled]="disabled"
>
  <ng-container *ngIf="icon && iconPosition === 'start'">
    <span class="icon">
      <ui-svg-icon [svgIcon]="icon" [size]="iconSize"></ui-svg-icon>
    </span>
  </ng-container>
  <span style="line-height: 140%" *ngIf="label" class="label">{{ label }}</span>
  <span style="line-height: 140%" *ngIf="abbreviation" class="label-abbreviation">
    {{ abbreviation }}
  </span>
  <ng-container *ngIf="icon && iconPosition === 'end'">
    <span class="icon">
      <ui-svg-icon [svgIcon]="icon" [size]="iconSize"></ui-svg-icon>
    </span>
  </ng-container>
</button>
